export { default as Toast } from './toast';
export { default as aesUtil } from './aesUtil';
export { default as rsaUtil } from './rsaUtil';

// 手机号脱敏
export const desensitizePhone = (phoneNumber: number | string) => {
  if (!phoneNumber) return null;
  const phoneStr = phoneNumber?.toString();
  return `${phoneStr.slice(0, 3)}****${phoneStr.slice(-4)}`;
};

/**
 * 将下划线key值改成小驼峰
 * @param obj
 * @returns `formatObj`
 */
export const convertObjectKeysToCamelCase = <T extends object>(obj?: T): T => {
  if (Array.isArray(obj)) {
    return obj.map(item => convertObjectKeysToCamelCase(item)) as T;
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((result, key) => {
      const newKey = key.replace(/_([a-z])/g, (m, p1) => p1.toUpperCase());
      // console.log( key, newKey, convertObjectKeysToCamelCase(obj[key]));
      result[newKey] = convertObjectKeysToCamelCase(obj[key]);
      return result;
    }, {} as T);
  }
  return obj;
};

/** 将字符串转换为JSON，并自动格式化下划线key为小驼峰形式 */
export const jsonParseWithFormatKey = <T extends JSONString<any>>(
  text: T
): T extends JSONString<infer R> ? (R extends object ? R : never) : never => {
  if (!text) return null;
  try {
    const obj = JSON.parse(text);
    const formatObj = convertObjectKeysToCamelCase(obj);
    return formatObj;
  } catch {
    // eslint-disable-next-line no-console
    console.error('解析json失败');
    return null;
  }
};

/**
 * 将对象中小驼峰key值改成下划线形式
 * @param obj
 * @returns `fomartObj`
 */
export const convertCamelToSnake = obj => {
  if (Array.isArray(obj)) {
    return obj.map(item => convertCamelToSnake(item));
  }

  const snakeCaseObj = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      const value = obj[key];

      if (typeof value === 'object' && value !== null) {
        snakeCaseObj[snakeCaseKey] = convertCamelToSnake(value);
      } else {
        snakeCaseObj[snakeCaseKey] = value;
      }
    }
  }
  return snakeCaseObj;
};
